import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationService } from '../../../core/services/confirmation.service';
import { PreventScrollDirective } from '../../../directives/prevent-scroll.directive';

@Component({
    selector: 'app-confirmation-modal',
    standalone: true,
    imports: [CommonModule, TranslateModule, PreventScrollDirective],
    templateUrl: './confirmation-modal.component.html',
    styleUrl: './confirmation-modal.component.css'
})
export class ConfirmationModalComponent {
    confirmationService = inject(ConfirmationService);

    /**
     * Resolve the confirmation modal with a positive result.
     */
    onConfirm(): void {
        this.confirmationService.resolve(true);
    }

    /**
     * Resolve the confirmation modal with a negative result.
     */
    onCancel(): void {
        this.confirmationService.resolve(false);
    }
}
